export enum MobileNavDirection {
  Left = 'left',
  Right = 'right',
}
